module.exports = __webpack_public_path__ + "img/motor_no17.0952f10b.jpg";